import React from 'react'

import { actionsColumn, conditionNameColumn, providersColumn, sitesColumn } from "Pages/ReportsAlerts/Alerts/Conditions/@components"
import AlertsBaseTable from "Pages/ReportsAlerts/Alerts/@components/Table"
import { ratingComparisonColumn } from "Pages/ReportsAlerts/Alerts/Conditions/Rating/Table/columns"


export default function RatingTable({ data, isLoading, onDeleteAlert, onEditAlert, filterConditions }) {

	return <AlertsBaseTable
		title="Alerts: Rating"
		data={data}
		isLoading={isLoading}
		filterConditions={filterConditions}
		columns={[
			conditionNameColumn(),
			...sitesColumn(),
			providersColumn(),
			ratingComparisonColumn(),
			actionsColumn(onDeleteAlert, onEditAlert)
		]}
		legend={[
			{
				icon: "less-than",
				value: "Lower than",
				label: "Less than",
				iconProps: { color: "error.main" }
			},
			{
				icon: "not-equal",
				value: "Different than",
				label: "Different than",
				iconProps: { color: "warning.main" }
			},
			{
				icon: "greater-than",
				value: "Higher than",
				label: "Greater than",
				iconProps: { color: "success.main" }
			},
			{
				icon: "star-sharp",
				label: "Rating Score",
				iconProps: { color: "warning.main" }
			},
		]}
	/>
}